<template>
  <div
    class="selected-item"
    :class="{'selected-item__error': item.disabled}"
  >
    <div
      v-overflow-title="item.name"
      class="selected-item__text"
    >
      {{ item.name }}
    </div>
    <div
      v-if="!disabled"
      class="selected-item__delete"
      @click="$emit('removeItem')"
    >
      <MIcon
        :icon="iconCross"
      />
    </div>
  </div>
</template>

<script>
  import iconCross from 'assets/icons/cross.svg';
  import MIcon from 'components/Design/MIcon';

  export default {
    name: 'SelectedItem',
    components: {MIcon},
    props: {
      item: {
        type: Object,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        iconCross
      };
    }
  };
</script>

<style>
  .selected-item {
    display: flex;

    background: var(--gray-table-color);

    border-radius: 4px;
  }

  .selected-item.selected-item__error {
    background: rgba(234, 173, 176, 0.5);
  }

  .selected-item__text {
    font-size: 12px;

    color: var(--secondary-text-color);
    text-overflow: ellipsis;

    white-space: nowrap;

    overflow: hidden;

    min-width: 0;

    padding: 4px 8px;
  }

  .selected-item__delete {
    color: var(--secondary-text-color);

    cursor: pointer;

    display: flex;

    width: 12px;
    height: 12px;

    margin: 5px 4px 5px auto;
  }

</style>
